import { ChannelMediaEditor } from "./channel-media-editor";
import { Button } from "@ondit/ui";
import { Trash2 } from "lucide-react";
import { fileUrl } from "~/common/media/api";
import { pick, useI18n } from "~/core/i18n";

export function SourceImageField({
	brandId,
	onBusyChange,
	value,
	assets,
	disabled,
	onChange,
}: {
	brandId?: string;
	onBusyChange?: (busy: boolean) => void;
	value: string;
	assets: { file_id: string; url: string; type: string; mime: string }[];
	disabled: boolean;
	onChange: (url: string) => void;
}) {
	const { locale } = useI18n();
	const images = assets.filter((asset) => asset.type === "image" && asset.mime.startsWith("image/"));
	const selected = images.find((asset) => asset.url === value);
	if (brandId)
		return (
			<ChannelMediaEditor
				brandId={brandId}
				assets={assets}
				value={value ? [{ url: value }] : []}
				onChange={(items) => onChange(items[0]?.url ?? "")}
				disabled={disabled}
				accept="image/*"
				maxCount={1}
				onBusyChange={onBusyChange}
			/>
		);
	return (
		<div className="smart-image-field">
			{value && (
				<div className="smart-image-selected">
					<img src={selected ? fileUrl(selected.file_id) : value} alt={pick(locale, ["Selected cover", "已选封面"])} />
					<Button
						variant="ghost"
						aria-label={pick(locale, ["Remove cover", "移除封面"])}
						disabled={disabled}
						onClick={() => onChange("")}
					>
						<Trash2 size={16} />
					</Button>
				</div>
			)}
			{images.length > 0 ? (
				<div
					className="smart-image-options"
					role="group"
					aria-label={pick(locale, ["Choose a cover from source images", "从素材图片中选择封面"])}
				>
					{images.map((asset, index) => (
						<Button
							key={asset.file_id}
							variant={asset.url === value ? "outline" : "ghost"}
							disabled={disabled}
							aria-pressed={asset.url === value}
							aria-label={pick(locale, [`Choose image ${index + 1}`, `选择图片 ${index + 1}`])}
							onClick={() => onChange(asset.url)}
						>
							<img src={fileUrl(asset.file_id)} alt="" />
						</Button>
					))}
				</div>
			) : (
				<p className="hint">
					{pick(locale, [
						"No source images. Add an image to the article material, save it, then start a new distribution plan.",
						"暂无素材图片。请先为文章素材添加图片并保存，再新建分发计划。",
					])}
				</p>
			)}
		</div>
	);
}
